<zest-loader></zest-loader>
<zest-header></zest-header>
<div class="page-container container" id="page-content">
    <router-outlet></router-outlet>
</div>
<zest-footer></zest-footer>